export const DEFAULT_MESSAGE_PAGE_SIZE = 50;
